import React, { useEffect, useState, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Badge,
  Spinner,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import classnames from "classnames";
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import toastr from 'toastr';
import "toastr/build/toastr.min.css";
import axios from "axios"; // Axios eklendi

// FIREBASE (Önceki düzeltmeye uygun)
import firebase from "firebase/compat/app";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

const UsersList = props => {
  document.title = "Kullanıcı Yönetimi | Subsea Admin";

  // --- API AYARLARI ---
  const API_URL = "https://subseaapi.stechomeyazilim.info/Users";

  // --- State Tanımları ---
  const [usersList, setUsersList] = useState([]);
  const [userEdit, setUserEdit] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  
  // Modal & Loading
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Tablo yükleniyor durumu

  // Resim Yükleme (Firebase)
  const [uploading, setUploading] = useState(false);
  const [downloadURL, setDownloadURL] = useState("");

  // --- API'den Verileri Çekme ---
  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(API_URL);
      // OData formatı genellikle 'value' içinde döner, yoksa direkt data
      const data = response.data.value || response.data;
      setUsersList(data);
    } catch (error) {
      console.error("Fetch error:", error);
      toastr.error("Kullanıcı listesi yüklenemedi.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // --- FIREBASE RESİM YÜKLEME ---
  const handleImageUpload = async (file) => {
    if (!file) return;
    try {
      setUploading(true);
      // Compat app ile storage instance oluşturuyoruz
      const storage = getStorage(firebase.app());
      const fileName = `users/${Date.now()}_${file.name}`;
      const storageRef = ref(storage, fileName);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on("state_changed", () => {}, (error) => {
          console.error("Upload Hatası:", error);
          toastr.error("Resim yüklenemedi: " + error.message);
          setUploading(false);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            setDownloadURL(url);
            setUploading(false);
            toastr.success("Profil resmi yüklendi.");
          });
        }
      );
    } catch (error) {
      console.error("Firebase Hatası:", error);
      setUploading(false);
    }
  };

 // --- Formik Yapılandırması ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      FullName: userEdit?.FullName || "",
      Email: userEdit?.Email || "",
      Phone: userEdit?.Phone || "",
      CompanyName: userEdit?.CompanyName || "",
      Location: userEdit?.Location || "",
      DateOfBirth: userEdit?.DateOfBirth ? userEdit.DateOfBirth.split('T')[0] : "",
      
      Password: "", 
      Role: userEdit?.Role || "user", // Tabloda default 'user'
      IsTwoFactorEnabled: userEdit?.IsTwoFactorEnabled || false,
      IsActive: userEdit?.IsActive ?? true,

      PrivacyContactVisibility: userEdit?.PrivacyContactVisibility || "all",
      PrefNotifyNewsletter: userEdit?.PrefNotifyNewsletter ?? true,
      PrefNotifyPriceChange: userEdit?.PrefNotifyPriceChange ?? true,
      PrefNotifyMessages: userEdit?.PrefNotifyMessages ?? true,
    },
    // Schema: Yeni kullanıcıda şifre zorunlu, düzenlemede opsiyonel
    validationSchema: Yup.object({
      FullName: Yup.string().nullable(),
      Email: Yup.string().email("Geçerli e-posta giriniz").required("E-posta zorunludur"),
      Role: Yup.string().required("Rol seçimi zorunludur"),
      Password: Yup.string().test("pwd-check", "Yeni kullanıcı için şifre zorunludur", function(val) {
          // Eğer düzenleme (isEdit) değilse (yani yeniyse), şifre (val) dolu olmalı
          if (!isEdit && !val) return false;
          return true;
      }),
    }),
    onSubmit: async (values) => {
      // 1. Payload Hazırlığı (Tablo kolonlarına birebir uyumlu)
      const userPayload = {
        Email: values.Email,
        FullName: values.FullName || null, // Boşsa null gönder (DB: NULL)
        Phone: values.Phone || null,       // Boşsa null gönder (DB: NULL)
        Role: values.Role,
        IsActive: values.IsActive,
        DateOfBirth: values.DateOfBirth ? new Date(values.DateOfBirth).toISOString() : null,
        Location: values.Location || null,
        ProfilePicture: downloadURL || (userEdit ? userEdit.ProfilePicture : null),
        CompanyName: values.CompanyName || null,
        IsTwoFactorEnabled: values.IsTwoFactorEnabled,
        PrivacyContactVisibility: values.PrivacyContactVisibility,
        PrefNotifyPriceChange: values.PrefNotifyPriceChange,
        PrefNotifyNewsletter: values.PrefNotifyNewsletter,
        PrefNotifyMessages: values.PrefNotifyMessages
      };

      // 2. Şifre Mantığı (KRİTİK BÖLÜM)
      // Tablonda 'Password' yok, 'PasswordHash' var. 
      // Backend hashlemiyorsa, buraya hashlenmiş veri gitmeli. 
      // Şimdilik düz metni PasswordHash'e atıyoruz (Backend bunu bekliyor olabilir).
      
      if (values.Password) {
        userPayload.PasswordHash = values.Password; 
      }

      // 3. ID Temizliği ve İstek Gönderme
      try {
        if (isEdit && userEdit) {
            // --- GÜNCELLEME (PUT) ---
            
            // Eğer şifre değişmiyorsa PasswordHash'i payload'dan silmeliyiz
            // Yoksa eski şifreyi boş string ile ezebiliriz.
            if (!values.Password) {
                delete userPayload.PasswordHash;
            }

            // ID'yi URL'den gönderiyoruz, Body'de OLMAMALI (Identity hatası verir)
            // userPayload içinde ID yok zaten, yukarıda elle oluşturduk.

            await axios.put(`${API_URL}(${userEdit.ID})`, userPayload);
            toastr.success("Kullanıcı güncellendi.");
        } else {
            // --- EKLEME (POST) ---
            
            // Tabloda PasswordHash 'NOT NULL'. Yeni kayıtta mutlaka gitmeli.
            if (!userPayload.PasswordHash) {
                toastr.error("Şifre alanı zorunludur.");
                return;
            }

            await axios.post(API_URL, userPayload);
            toastr.success("Kullanıcı oluşturuldu.");
        }
        toggle();
        fetchUsers(); 
      } catch (error) {
        console.error("İşlem Hatası:", error);
        // Backend'den dönen hatayı yakala
        const errorMsg = error.response?.data?.error?.message || error.response?.data?.message || "İşlem sırasında sunucu hatası (500).";
        toastr.error(`Hata: ${errorMsg}`);
      }
    },
  });
  

  // --- Helpers ---
  const toggle = () => {
    setModal(!modal);
    if (!modal && !isEdit) {
       validation.resetForm();
       setDownloadURL("");
       setActiveTab("1");
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleUserClick = (user) => {
    setUserEdit(user);
    setDownloadURL(user.ProfilePicture);
    setIsEdit(true);
    setModal(true);
  };

  const handleDeleteClick = (user) => {
    setUserToDelete(user);
    setDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (userToDelete) {
        try {
            await axios.delete(`${API_URL}(${userToDelete.ID})`);
            toastr.success("Kullanıcı silindi.");
            fetchUsers();
        } catch (error) {
            console.error("Delete error:", error);
            toastr.error("Silme işlemi başarısız.");
        }
    }
    setDeleteModal(false);
  };

  const handleAddClick = () => {
    setUserEdit(null);
    setIsEdit(false);
    setDownloadURL("");
    setActiveTab("1");
    setModal(true);
  };

  // --- Columns ---
  const columns = useMemo(() => [
      { Header: "#", accessor: "ID", width: 50 },
      {
        Header: "Profil",
        accessor: "ProfilePicture",
        disableFilters: true,
        Cell: (cellProps) => (
          <div className="avatar-xs">
            {cellProps.value ? (
              <img className="rounded-circle header-profile-user" src={cellProps.value} alt="Avatar" style={{objectFit: 'cover', width:'100%', height:'100%'}} />
            ) : (
              <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-16">
                {cellProps.row.original.FullName?.charAt(0)}
              </span>
            )}
          </div>
        ),
      },
      { Header: "Ad Soyad", accessor: "FullName", filterable: true },
      { Header: "E-Posta", accessor: "Email", filterable: true },
      { 
        Header: "Rol", 
        accessor: "Role",
        Cell: (cellProps) => {
            const colors = { 'admin': 'danger', 'company_admin': 'warning', 'user': 'primary' };
            return <Badge color={colors[cellProps.value] || 'secondary'}>{cellProps.value}</Badge>
        }
      },
      { Header: "Firma", accessor: "CompanyName", filterable: true },
      {
        Header: "Durum",
        accessor: "IsActive",
        Cell: (cellProps) => <Badge color={cellProps.value ? "success" : "light"}>{cellProps.value ? "Aktif" : "Pasif"}</Badge>,
      },
      {
        Header: "İşlemler",
        Cell: cellProps => (
            <div className="d-flex gap-2">
              <button className="btn btn-sm btn-soft-info" onClick={() => handleUserClick(cellProps.row.original)}>
                <i className="mdi mdi-pencil" />
              </button>
              <button className="btn btn-sm btn-soft-danger" onClick={() => handleDeleteClick(cellProps.row.original)}>
                <i className="mdi mdi-delete" />
              </button>
            </div>
        ),
      },
    ], []
  );

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={confirmDelete} onCloseClick={() => setDeleteModal(false)} />
      
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcılar" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {isLoading ? (
                      <div className="text-center m-5">
                          <Spinner color="primary" />
                          <p className="mt-2">Yükleniyor...</p>
                      </div>
                  ) : (
                    <TableContainer
                        columns={columns}
                        data={usersList}
                        isGlobalFilter={true}
                        isAddUser={true}
                        handleOrderClicks={handleAddClick}
                        customPageSize={10}
                        className="custom-header-css"
                    />
                  )}

                  {/* --- MODAL --- */}
                  <Modal isOpen={modal} toggle={toggle} size="lg">
                    <ModalHeader toggle={toggle} tag="h4">
                      {isEdit ? "Kullanıcı Düzenle" : "Yeni Kullanıcı Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form onSubmit={e => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                        
                        <Nav tabs className="nav-tabs-custom mb-3">
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")}>
                                    <i className="mdi mdi-account me-1"></i> Hesap Bilgileri
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")}>
                                    <i className="mdi mdi-lock me-1"></i> Login & Güvenlik
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")}>
                                    <i className="mdi mdi-bell-ring me-1"></i> Tercihler
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab} className="p-3 text-muted">
                            
                            {/* TAB 1 */}
                            <TabPane tabId="1">
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <Label>Ad Soyad *</Label>
                                        <Input name="FullName" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.FullName} invalid={!!(validation.touched.FullName && validation.errors.FullName)} />
                                        <FormFeedback>{validation.errors.FullName}</FormFeedback>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Label>E-Posta *</Label>
                                        <Input name="Email" type="email" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.Email} invalid={!!(validation.touched.Email && validation.errors.Email)} />
                                        <FormFeedback>{validation.errors.Email}</FormFeedback>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Label>Telefon</Label>
                                        <Input name="Phone" type="text" onChange={validation.handleChange} value={validation.values.Phone} />
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Label>Firma Adı</Label>
                                        <Input name="CompanyName" type="text" onChange={validation.handleChange} value={validation.values.CompanyName} />
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Label>Konum</Label>
                                        <Input name="Location" type="text" onChange={validation.handleChange} value={validation.values.Location} />
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Label>Doğum Tarihi</Label>
                                        <Input name="DateOfBirth" type="date" onChange={validation.handleChange} value={validation.values.DateOfBirth} />
                                    </Col>
                                    
                                    <Col md={12} className="mt-2 p-3 bg-light rounded">
                                        <Label>Profil Resmi (Firebase)</Label>
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="avatar-md">
                                                {downloadURL ? (
                                                    <img src={downloadURL} alt="Preview" className="img-thumbnail rounded-circle h-100 w-100 object-cover" />
                                                ) : (
                                                    <div className="avatar-title rounded-circle bg-soft-secondary text-secondary"><i className="mdi mdi-camera font-size-24"></i></div>
                                                )}
                                            </div>
                                            <div className="flex-grow-1">
                                                <Input type="file" accept="image/*" onChange={(e) => { if(e.target.files[0]) handleImageUpload(e.target.files[0]); }} />
                                                {uploading && <div className="mt-1 text-primary"><Spinner size="sm"/> Yükleniyor...</div>}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>

                            {/* TAB 2 */}
                            <TabPane tabId="2">
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <Label>Kullanıcı Rolü *</Label>
                                        <Input type="select" name="Role" value={validation.values.Role} onChange={validation.handleChange}>
                                            <option value="user">User</option>
                                            <option value="company_admin">Company Admin</option>
                                            <option value="admin">Super Admin</option>
                                        </Input>
                                    </Col>
                                    
                                    <Col md={6} className="mb-3">
                                        <Label>Şifre {isEdit && <small className="text-muted">(Boş bırakılırsa değişmez)</small>}</Label>
                                        <Input name="Password" type="password" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.Password} invalid={!!(validation.touched.Password && validation.errors.Password)} />
                                        <FormFeedback>{validation.errors.Password}</FormFeedback>
                                    </Col>

                                    <Col md={12} className="mt-3">
                                        <div className="form-check form-switch mb-3">
                                            <Input type="checkbox" className="form-check-input" id="IsActive" name="IsActive" checked={validation.values.IsActive} onChange={validation.handleChange} />
                                            <Label className="form-check-label" htmlFor="IsActive">Hesap Aktif</Label>
                                        </div>
                                        <div className="form-check form-switch">
                                            <Input type="checkbox" className="form-check-input" id="IsTwoFactorEnabled" name="IsTwoFactorEnabled" checked={validation.values.IsTwoFactorEnabled} onChange={validation.handleChange} />
                                            <Label className="form-check-label" htmlFor="IsTwoFactorEnabled">2FA Etkin</Label>
                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>

                            {/* TAB 3 */}
                            <TabPane tabId="3">
                                <Row>
                                    <Col md={12} className="mb-4">
                                        <Label>Gizlilik</Label>
                                        <Input type="select" name="PrivacyContactVisibility" value={validation.values.PrivacyContactVisibility} onChange={validation.handleChange}>
                                            <option value="all">Herkes</option>
                                            <option value="registered">Üyeler</option>
                                            <option value="none">Gizli</option>
                                        </Input>
                                    </Col>

                                    <Col md={12}>
                                        <h6 className="text-muted">Bildirimler</h6>
                                        <div className="form-check form-switch mb-2">
                                            <Input type="checkbox" className="form-check-input" id="PrefNotifyNewsletter" name="PrefNotifyNewsletter" checked={validation.values.PrefNotifyNewsletter} onChange={validation.handleChange} />
                                            <Label className="form-check-label" htmlFor="PrefNotifyNewsletter">Bülten</Label>
                                        </div>
                                        <div className="form-check form-switch mb-2">
                                            <Input type="checkbox" className="form-check-input" id="PrefNotifyPriceChange" name="PrefNotifyPriceChange" checked={validation.values.PrefNotifyPriceChange} onChange={validation.handleChange} />
                                            <Label className="form-check-label" htmlFor="PrefNotifyPriceChange">Fiyat Değişimi</Label>
                                        </div>
                                        <div className="form-check form-switch mb-2">
                                            <Input type="checkbox" className="form-check-input" id="PrefNotifyMessages" name="PrefNotifyMessages" checked={validation.values.PrefNotifyMessages} onChange={validation.handleChange} />
                                            <Label className="form-check-label" htmlFor="PrefNotifyMessages">Yeni Mesaj</Label>
                                        </div>
                                    </Col>
                                </Row>
                            </TabPane>

                        </TabContent>

                        <div className="text-end mt-4">
                            <button type="button" className="btn btn-secondary me-2" onClick={toggle}>İptal</button>
                            <button type="submit" className="btn btn-success" disabled={uploading}>{isEdit ? "Güncelle" : "Kaydet"}</button>
                        </div>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UsersList);